import { render, staticRenderFns } from "./ClassroomDetailTabItemStudents.vue?vue&type=template&id=680108ea&scoped=true"
import script from "./ClassroomDetailTabItemStudents.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabItemStudents.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTabItemStudents.vue?vue&type=style&index=0&id=680108ea&prod&lang=stylus&scoped=true"
import style1 from "./ClassroomDetailTabItemStudents.vue?vue&type=style&index=1&id=680108ea&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680108ea",
  null
  
)

export default component.exports